import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { githubApi } from '../services/githubApi';
import Loading from '../components/Loading';
import Error from '../components/Error';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const checkMainCard = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      
      const result = await githubApi.fetchCards();
      
      if (result.success && result.data) {
        const { settings } = result.data;
        
        // If there's a main card, redirect to it
        if (settings.mainCard) {
          navigate(`/card/${settings.mainCard}`);
          return;
        }
        
        // If no main card, redirect to login
        navigate('/login');
      } else {
        setError(result.error || 'Failed to load settings');
      }
    } catch (err) {
      setError('Failed to load application');
      console.error('Error loading home:', err);
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    checkMainCard();
  }, [checkMainCard]);

  const handleRetry = () => {
    setLoading(true);
    setError('');
    checkMainCard();
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Loading fullScreen text="Loading..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Error 
          message={error} 
          onRetry={handleRetry}
        />
      </div>
    );
  }

  // This should not be reached due to navigation
  return null;
};

export default Home; 